export * from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/model';
export { fetchModel } from './cloneEditorModel';

import type { StayDatesComponentProps } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/StayDatesComponent';

export const StayDatesComponent = {
    MountAsync: async (target: HTMLElement, props: StayDatesComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { StayDatesComponent } = await import('@digitalopsdev/serviceops-reservations-components/dist/EditReservation/StayDatesComponent');
        return await mountReactComponentAsync(target, StayDatesComponent, props);
    }
};

import type { OrderDetailsComponentProps } from "@digitalopsdev/serviceops-reservations-components/dist/EditReservation/OrderDetailsComponent";

export const OrderDetailsComponent = {
    MountAsync: async (target: HTMLElement, props: OrderDetailsComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { OrderDetailsComponent } = await import("@digitalopsdev/serviceops-reservations-components/dist/EditReservation/OrderDetailsComponent");
        return await mountReactComponentAsync(target, OrderDetailsComponent, props);
    }
};

import type { RoomsComponentProps } from "@digitalopsdev/serviceops-reservations-components/dist/EditReservation/RoomsComponent";

export const RoomsComponent = {
    MountAsync: async (target: HTMLElement, props: RoomsComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { RoomsComponent } = await import("@digitalopsdev/serviceops-reservations-components/dist/EditReservation/RoomsComponent");
        return await mountReactComponentAsync(target, RoomsComponent, props);
    }
};

import type { ProgramsComponentProps } from "@digitalopsdev/serviceops-reservations-components/dist/EditReservation/ProgramsComponent";

export const ProgramsComponent = {
    MountAsync: async (target: HTMLElement, props: ProgramsComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { ProgramsComponent } = await import("@digitalopsdev/serviceops-reservations-components/dist/EditReservation/ProgramsComponent");
        return await mountReactComponentAsync(target, ProgramsComponent, props);
    }
};

import type { ChangeTrackerComponentProps } from './ChangeTrackerComponent';

export const ChangeTrackerComponent = {
    MountAsync: async (target: HTMLElement, props: ChangeTrackerComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { ChangeTrackerComponent } = await import('./ChangeTrackerComponent');
        return await mountReactComponentAsync(target, ChangeTrackerComponent, props);
    }
};

import type { SaveReservationComponentProps } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/SaveReservationComponent';

export const SaveReservationComponent = {
    MountAsync: async (target: HTMLElement, props: SaveReservationComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { SaveReservationComponent } = await import('@digitalopsdev/serviceops-reservations-components/dist/EditReservation/SaveReservationComponent');
        return await mountReactComponentAsync(target, SaveReservationComponent, props);
    }
};

import type { PaymentsComponentProps } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/PaymentsComponent';

export const PaymentsComponent = {
    MountAsync: async (target: HTMLElement, props: PaymentsComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { PaymentsComponent } = await import('@digitalopsdev/serviceops-reservations-components/dist/EditReservation/PaymentsComponent');
        return await mountReactComponentAsync(target, PaymentsComponent, props);
    }
};

import type { TopRightComponentProps } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/TopRightComponent';

export const TopRightComponent = {
    MountAsync: async (target: HTMLElement, props: TopRightComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { TopRightComponent } = await import('@digitalopsdev/serviceops-reservations-components/dist/EditReservation/TopRightComponent');
        return await mountReactComponentAsync(target, TopRightComponent, props);
    }
};

import type { HistoryComponentProps } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/HistoryComponent';

export const HistoryComponent = {
    MountAsync: async (target: HTMLElement, props: HistoryComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { HistoryComponent } = await import('@digitalopsdev/serviceops-reservations-components/dist/EditReservation/HistoryComponent');
        return await mountReactComponentAsync(target, HistoryComponent, props);
    }
};

import type { ProfileComponentProps } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/ProfileComponent';

export const ProfileComponent = {
    MountAsync: async (target: HTMLElement, props: ProfileComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { ProfileComponent } = await import('@digitalopsdev/serviceops-reservations-components/dist/EditReservation/ProfileComponent');
        return await mountReactComponentAsync(target, ProfileComponent, props);
    }
};


import type { TransferDetailsComponentProps } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/TransferDetailsComponent';

export const TransferDetailsComponent = {
    MountAsync: async (target: HTMLElement, props: TransferDetailsComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { TransferDetailsComponent } = await import('@digitalopsdev/serviceops-reservations-components/dist/EditReservation/TransferDetailsComponent');
        return await mountReactComponentAsync(target, TransferDetailsComponent, props);
    }
};


import type { EditReservationDialogComponentProps } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/EditReservationDialogComponent';
import { programDurationLabel } from '../../../js/programOperatingDays';

export const EditReservationDialogComponent = {
    MountAsync: async (target: HTMLElement, props: EditReservationDialogComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { EditReservationDialogComponent } = await import('@digitalopsdev/serviceops-reservations-components/dist/EditReservation/EditReservationDialogComponent');
        const { cloneAdapterForPopup } = await import('./cloneReservationAdapter');
        const cloneAdapter = cloneAdapterForPopup(target, () => root.unmount());
        const root = await mountReactComponentAsync(target, EditReservationDialogComponent, {
            ...props, cloneAdapter, clientSettings: { ...props.clientSettings, programDurationLabel }
        });
        return root;
    }
};

export * from './model.Hooks';
